import { Dispatch, SetStateAction } from 'react';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { IconButton, useTheme } from '@mui/material';

interface HideAvatarButtonProps {
    setIsAvatarVisible: Dispatch<SetStateAction<boolean>>;
}

const HideAvatarButton = ({ setIsAvatarVisible }: HideAvatarButtonProps) => {
    const theme = useTheme();
    return (
        <IconButton
            onClick={() => setIsAvatarVisible(false)}
            sx={{
                position: 'absolute',
                top: theme.spacing(2),
                left: theme.spacing(2),
                zIndex: 1000,
            }}
        >
            <ArrowForwardIosIcon sx={{ color: 'white', width: 20, height: 20 }} />
        </IconButton>
    );
};

export default HideAvatarButton;
